import React, { useContext, useState } from "react";
import { ThemeContext } from "../contexts/ThemeContext";
import { LanguageContext } from "../contexts/LanguageContext";
import { useTranslation } from "react-i18next";

function RespNav() {
  const [showFilterPopup, setShowFilterPopup] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null); // Add this state
    const { theme, toggleTheme } = useContext(ThemeContext);
  const [animationState, setAnimationState] = useState('');
  const { language, changeLanguage } = useContext(LanguageContext);
    const { t } = useTranslation("home");
  
  const handleOpen = () => {
    setShowFilterPopup(true);
    setAnimationState('opening');
  };

  const handleClose = () => {
    setAnimationState('closing');
    setTimeout(() => {
      setShowFilterPopup(false);
      setAnimationState('');
    }, 300); // Match animation duration
  };

  const handleLanguageChange = lang => {
    changeLanguage(lang);
  };




  return (
    <div className="nav_responsive">
      <div className='resp_nav'>
        <div>
          <img alt='' src='/assets/images/white/logo.svg' width='73' height='63' className='d-inline-block align-top' />
        </div>
        <div className="resp_nav_menu" onClick={handleOpen}>
          <img alt='' src={`/assets/images/${theme}/toggle_menu.svg`} />
        </div>
        {showFilterPopup &&
          <div className={`filter-nav-popup ${animationState}`}>
            <div className="w-100 d-felx justify-content-end">
              <button className="close-btn" onClick={handleClose}>X</button>
            </div>
            
            
        <div className='d-flex d-felx flex-column'>
        <a href="/" className='nav_1_item'><span className='nav_item_title'>{t('home')}</span> </a>
        
        <a href="" className='nav_1_item'><span className='nav_item_title'>{t('categories')}</span>  </a>
        <a href="" className='nav_1_item'> <span className='nav_item_title'>{t('about_us')}</span> </a>
        <a href="" className='nav_1_item'><span className='nav_item_title'>{t('contact_us')}</span>  </a>


          <div className='nav_1_item'>
            <img src={`/assets/images/${theme}/user.svg`} className='nav_item_image' alt='' />
            <span className='nav_item_title'>{t("login")}</span>
          </div>
          <a href='' className='nav_1_item'>
            <img src={`/assets/images/${theme}/wishlist.svg`} className='nav_item_image' alt='' />
            <span className='nav_item_title'> {t("wishlist")}</span>
          </a>
          <a href='' className='nav_1_item'>
            <img src={`/assets/images/${theme}/cart.svg`} className='nav_item_image' alt='' />
            <span className='nav_item_title'> {t("cart")}</span>
          </a>
          {/* ================== lang and display ========================== */}
            <div className='d-flex align-items-center nav_1_item '>
            <button
              className={`btn nav_item_lang nav_lang_item ${language === "en" ? "active_lang" : ""}`}
              onClick={() => handleLanguageChange("en")}>
              {" "}
              EN{" "}
            </button>
            <span className='sperator_lang'></span>
            <button
              className={`btn nav_item_lang nav_lang_item ${language === "ar" ? "active_lang" : ""}`}
              onClick={() => handleLanguageChange("ar")}>
              {" "}
              Ar{" "}
            </button>
          </div>

                    <a href='' className='nav_1_item'>
            <img src={`/assets/images/${theme}/theme.svg`} className='nav_item_image' alt='' onClick={toggleTheme} />
          </a>
        </div>
          </div>}
      </div>

    </div>

  );
}

export default RespNav;
